{
  "title": "Magic Stone",
  "source": "Xanathar's Guide to Everything/Elemental Evil Player's Companion",
  "levelAndSchool": "Transmutation cantrip",
  "level": 0,
  "castingTime": "1 bonus action",
  "range": "Touch",
  "components": "V, S",
  "duration": "1 minute",
  "description": [
    "You touch one to three pebbles and imbue them with magic. You or someone else can make a ranged spell attack with one of the pebbles by throwing it or hurling it with a sling. If thrown, it has a range of 60 feet. If someone else attacks with the pebble, that attacker adds your spellcasting ability modifier, not the attacker’s, to the attack roll. On a hit, the target takes bludgeoning damage equal to 1d6 + your spellcasting ability modifier. Hit or miss, the spell then ends on the stone.",
    "If you cast this spell again, the spell ends early on any pebbles still affected by it."
  ],
  "spellLists": ["artificer", "druid", "warlock"]
}
